var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKnifeOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3482 3.79609C18.3902 2.75673 20.073 2.73197 21.1454 3.74019C22.2598 4.78794 22.2881 6.545 21.208 7.62789L16.4728 12.3754L17.1347 13.0349C17.356 13.2554 17.4509 13.5473 17.3729 13.8816C17.3328 14.0457 17.2459 14.1893 17.1452 14.323C17.0466 14.4541 16.8889 14.6378 16.6278 14.9083C15.549 16.0259 14.3641 17.0466 13.1931 18.0648C11 20 9.03254 20.438 6.97677 20.8C5.5 21 4.1364 21 3.49475 21C1.99423 21 1.49412 19.5047 2.5945 18.4081L11.9712 9.15938L11.9736 9.15699L17.3482 3.79609ZM12.606 11.0601C12.606 11.0601 7.5 16 4.45683 19.1275C7.79821 19.1275 10 18.5 12.8 16C14.6215 14.4162 14.7884 14.2197 15.2759 13.7202L12.606 11.0601ZM15.1995 11.1067L19.931 6.3629C20.2971 5.99589 20.2875 5.40052 19.9098 5.04539C19.5461 4.70347 18.9753 4.71188 18.622 5.06434L13.8811 9.79313L15.1995 11.1067Z",
    fill: "#023F80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKnifeOutline);
export default __webpack_public_path__ + "static/media/knife_outline.357a1ed7f1b175c080473f2a1710414f.svg";
export { ForwardRef as ReactComponent };